import * as React from "react";
import { useUIFacade } from "../../../../../../../ui/facades/ui.facade";
import DateTemplate from "../../../../../../../ui/templates/columns/DateTemplate";
import NameTemplate from "../../../../../../../ui/templates/columns/NameTemplate";
import PriorityTemplate from "../../../../../../../ui/templates/columns/PriorityTemplate";
import ValueTemplate from "../../../../../../../ui/templates/columns/ValueTemplate";
import PrwcDataTableBasic from "../../../../../../../ui/widgets/custom/PrwcDataTableBasic";


const UserAttributes = () => {
  const uiFacade = useUIFacade();

  const handleOnDelete = (event: any, rowData: any) => {
    uiFacade.showConfirmDeletePopup(event, rowData, deleteAttribute);
  };

  const handleOnEdit = (rowData: any) => {
    console.log(rowData);
  };

  const deleteAttribute = (rowData: any) => {
    console.log('delete attribute called ---');
    console.log(rowData);
  }

  const actionTemplate = (rowData: any) => {
    return (
      <div className="flex">
        <i
          id="delete_icon"
          className="mr-1 text-xs cursor-pointer pi pi-trash"
          onClick={(e: any) => handleOnDelete(e, rowData)}
        ></i>
        <i
          className="text-xs cursor-pointer pi pi-pencil"
          onClick={(e: any) => handleOnEdit(rowData)}
        ></i>
      </div>
    );
  };

  const data = [
    {
      id: 1,
      name: "Attribute 1",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 1,
    },
    {
      id: 2,
      name: "Attribute 2",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 2,
    },
    {
      id: 3,
      name: "Attribute 3",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 3,
    },
    {
      id: 4,
      name: "Attribute 4",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 1,
    },
    {
      id: 5,
      name: "Attribute 5",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 2,
    },
  ];

  const dataTable = {
    columns: [
      {
        field: "attribute",
        headerLabelKey: "users.label.attribute",
        bodyTemplate: NameTemplate,
        templateArgument: "name",
        className: "w-14 text-xs font-semibold text-blue-700",
      },
      {
        field: "value",
        headerLabelKey: "users.label.value",
        bodyTemplate: ValueTemplate,
        templateArgument: "name",
        className: "w-14 text-xs",
      },
      {
        field: "validFrom",
        headerLabelKey: "users.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-14 text-xs",
      },
      {
        field: "validTo",
        headerLabelKey: "users.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-14 text-xs",
      },
      {
        field: "priority",
        headerLabelKey: "users.label.priority",
        bodyTemplate: PriorityTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "action",
        bodyTemplate: actionTemplate,
        className: "w-6 text-xs",
      },
    ],
  };

  return (
    <div>
      <PrwcDataTableBasic
        data={data}
        columns={dataTable.columns}
      ></PrwcDataTableBasic>
    </div>
  );
};

export default UserAttributes;
